import { render, staticRenderFns } from "./CustomerTable2.vue?vue&type=template&id=83e96542&"
import script from "./CustomerTable2.vue?vue&type=script&lang=js&"
export * from "./CustomerTable2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports